import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosError, AxiosResponse } from "axios";
import { FormConfiguration } from "../components/model/form-configuration";
import { url } from "../components/model/url-endpoint";

const initialState: FormConfiguration = {
  form: {
    id: "",
    uuid: "",
    name: "",
    sections: [],
  },
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setConfiguration: (state, action: PayloadAction<FormConfiguration>) => {
      return {
        ...state,
        form: action.payload.form,
      };
    },
  },
});

export const fetchFormConfiguration = (queryParams: URLSearchParams) => {
  return (dispatch: Dispatch<any>) => {
    axios
      .post(url + "get_configuration", {
        coi: queryParams.get("coi"),
        form: { uuid: queryParams.get("form") },
      })
      .then((response: AxiosResponse) => {
        dispatch(formActions.setConfiguration(response.data));
      })
      .catch((error: AxiosError) => {
     //   console.log(error);
      });
  };
};

export default formSlice;
export const formActions = formSlice.actions;
